
import cer1 from "../img/Certificates/cer1.jpg";
import cer2 from "../img/Certificates/cer2.jpg";
import cer3 from "../img/Certificates/cer3.jpg";
import cer4 from "../img/Certificates/cer4.jpg";
import cer5 from "../img/Certificates/cer5.jpg";
import cer6 from "../img/Certificates/cer6.jpg";
import cer7 from "../img/Certificates/cer7.jpg";
import cer8 from "../img/Certificates/cer8.jpg";
import cer9 from "../img/Certificates/cer9.jpg";
import cer10 from "../img/Certificates/cer10.jpg";
import cer11 from "../img/Certificates/cer11.jpg";
import cer12 from "../img/Certificates/cer12.jpg";


export const certificatesList = [
    {
        img: cer1,
        title: "Certyfikat ukończenia kursu Zaawansowane projekty w CSS i JavaScript",
    },
    {
        img: cer2,
        title: "Certyfikat ukończenia kursu Front-end zaawansowany",
    },
    {
        img: cer3,
        title: "Certyfikat ukończenia kursu Programowanie w JavaScript",
    },
    {
        img: cer4,
        title: "Certyfikat ukończenia kursu Search Engine Optimization",
    },
    {
        img: cer5,
        title: "Certyfikat ukończenia kursu React od podstaw",
    },
    {
        img: cer6,
        title: "Certyfikat ukończenia kursu Tworzenia stron www cz. I",
    },
    {
        img: cer7,
        title: "Certyfikat ukończenia kursu Tworzenia stron www cz. II",
    },
    {
        img: cer8,
        title: "Certyfikat ukończenia kursu 10 projektów w czystym JavaScript",
    },
    {
        img: cer9,
        title: "Certyfikat ukończenia kursu 15 komponentów na strony www",
    },
    {
        img: cer10,
        title: "Certyfikat ukończenia kursu Frontend Developer bootcamp",
    },
    {
        img: cer11,
        title: "Certyfikat ukończenia kursu tworzenia stron internetowych w oparciu o CMS WordPres",
    },
    {
        img: cer12,
        title: "Certyfikat ukończenia kursu SEO pozycjonowania stron internetowych",
    },
]